export function extractOptionsData(intervalOptions, shortMinuteKey, showNoneOption, noneOptionText, selectedValue) {
    const res = intervalOptions.split(",").map(option => alignContractForOption(option, shortMinuteKey, selectedValue.toString()));
    if (showNoneOption) {
        res.unshift(["0", noneOptionText, selectedValue.toString() === "0"]);
    }
    return res.map(generateOption);
}
const alignContractForOption = (option, shortMinuteKey, selectedValue) => [option, `${option} ${shortMinuteKey}`, option === selectedValue];
const generateOption = ([value, label, selected]) => ({ value, label, selected });
//# sourceMappingURL=extractOptionsData.js.map